import { render } from "./FixtureDetails.vue?vue&type=template&id=7ae6dbb8&scoped=true"
import script from "./FixtureDetails.vue?vue&type=script&lang=js"
export * from "./FixtureDetails.vue?vue&type=script&lang=js"

import "./FixtureDetails.vue?vue&type=style&index=0&id=7ae6dbb8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae6dbb8"]])

export default __exports__